import { useMemo } from 'react';
import { CheckBox, Text } from '@rsos/components/capstone/base';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';
import {
  convertMillSecToMin,
  convertMillSecToDay,
  customUnixTimestamp,
} from '../../utils/helpers';
import {
  TableData,
  TableBody as Body,
  TableRow,
} from '../styles/CommunicationHistoryTable.styles';

export const CommunicationHistoryTableBody = ({
  displayList,
  checkedList,
  handleCheckedData,
}) => {
  const textData = useMemo(
    () =>
      displayList.map(d => {
        const isChecked = Boolean(checkedList[d.conversation_id]);
        const remainingDays = convertMillSecToDay(d.time_until_expiration);
        const duration = convertMillSecToMin(d.duration);
        return (
          <TableRow key={d.conversation_id}>
            <TableData>
              <CheckBox
                type="checkbox"
                noText
                name={d.conversation_id}
                isChecked={isChecked}
                onChange={() => handleCheckedData(d.conversation_id)}
              />
            </TableData>
            <TableData>
              <Text ellipsis size={'normal'}>
                {formatInternationalPhoneNumberHuman(d.phone_number)}
              </Text>
            </TableData>
            <TableData>
              <Text size={'normal'}>{customUnixTimestamp(d.start_time)}</Text>
            </TableData>
            <TableData>
              <Text ellipsis size={'normal'}>
                {duration < 1 ? `< 1 minute` : `${Math.ceil(duration)} minutes`}
              </Text>
            </TableData>
            <TableData>
              <Text
                ellipsis
                size={'normal'}
                color={remainingDays < 4 ? 'lightDanger' : 'inherit'}
              >
                {remainingDays < 1
                  ? '< 1 Day'
                  : `${Math.ceil(remainingDays)} Days`}
              </Text>
            </TableData>
            {/* act as spacer for download column */}
            <TableData></TableData>
          </TableRow>
        );
      }),
    [displayList, checkedList, handleCheckedData],
  );
  return <Body>{textData}</Body>;
};
